import React from 'react';
import PropTypes from 'prop-types';
import StripeCardProp from '../../propTypes/StripeCardProp';
import { compose } from '../../../../services/utilityFunctions';
import { useCards } from '../../../../services/customHooks';
import withCSRF from '../../../../commonComponents/withCSRF';
import translate from '../../../../commonComponents/translate';
import FormHeader from '../../../../commonComponents/forms/FormHeader';
import CardSelector from './payment/creditCardSelector/CreditCardSelector';

/**
 * Form to update the current logged user's credit card information
 */
function PaymentForm({ t, _csrf, cards: propCards, onCardsChange, fromSubscriptionOrders }) {
  const { cards, handleAddCard, handleRemoveCard, handleSelectCard } = useCards(
    _csrf,
    'credit-card-container',
    propCards,
    onCardsChange,
  );

  return (
    <>
      <div
        className="m-form m-form--fit m-form--label-align-right"
        id="credit-card-container"
      >
        <div className="m-portlet__body">
          {
            !fromSubscriptionOrders && (
              <FormHeader title={`${t('payment_info')}`} />
            )
          }
          <CardSelector
            cards={cards}
            isModeSelection
            onSelectCard={handleSelectCard}
            onAddCard={handleAddCard}
            onRemoveCard={handleRemoveCard}
          />
        </div>
      </div>
    </>
  );
}

PaymentForm.propTypes = {
  t: PropTypes.func.isRequired,
  _csrf: PropTypes.string.isRequired,
  cards: PropTypes.arrayOf(PropTypes.shape(StripeCardProp.propType)).isRequired,
  onCardsChange: PropTypes.func.isRequired,
  fromSubscriptionOrders: PropTypes.bool,
};
PaymentForm.defaultProps = {
  fromSubscriptionOrders: false,
};

export default compose(
  withCSRF,
  translate,
)(PaymentForm);
